import React from "react";
import { PROCESS, ABOUT } from "../mock";
import { CheckCircle2 } from "lucide-react";

const Process = () => {
  return (
    <>
      {/* About / band */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="overflow-hidden rounded-[28px] shadow-2xl shadow-[var(--brand)]/15">
              <img src={ABOUT.image} alt="Warehouse operations" className="h-[420px] w-full object-cover" />
            </div>
            <div className="absolute -top-6 -right-6 hidden sm:block rounded-2xl bg-[var(--accent)] px-6 py-5 shadow-xl">
              <p className="font-heading text-3xl font-extrabold text-[var(--ink)] leading-none">10+ yrs</p>
              <p className="text-sm font-medium text-[var(--ink)]/70 mt-1">Sourcing expertise</p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="text-sm font-bold uppercase tracking-wider text-[var(--brand)]">Who We Are</span>
            <h2 className="mt-3 font-heading text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-[var(--ink)]">
              {ABOUT.title}
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-[var(--muted-ink)]">{ABOUT.description}</p>
            <div className="mt-7 grid sm:grid-cols-2 gap-4">
              {ABOUT.bullets.map((b) => (
                <div key={b} className="flex items-start gap-3">
                  <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-[var(--brand)]" />
                  <span className="font-medium text-[var(--ink)]">{b}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Process steps */}
      <section id="process" className="py-20 lg:py-28 bg-[var(--soft)]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <span className="text-sm font-bold uppercase tracking-wider text-[var(--brand)]">How It Works</span>
            <h2 className="mt-3 font-heading text-4xl lg:text-5xl font-extrabold tracking-tight text-[var(--ink)]">
              Sourcing made simple in 4 steps
            </h2>
          </div>

          <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {PROCESS.map((step, i) => {
              const Icon = step.icon;
              return (
                <div key={step.step} className="relative rounded-2xl bg-white p-7 shadow-[0_4px_20px_rgba(17,17,26,0.05)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_rgba(108,92,231,0.14)]">
                  <span className="font-heading text-5xl font-extrabold text-[var(--brand)]/12">{step.step}</span>
                  <span className="absolute right-7 top-7 flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--brand)]/10 text-[var(--brand)]">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-[var(--ink)]">{step.title}</h3>
                  <p className="mt-2.5 text-[15px] leading-relaxed text-[var(--muted-ink)]">{step.description}</p>
                  {i < PROCESS.length - 1 && (
                    <div className="absolute -right-3 top-1/2 hidden lg:block h-0.5 w-6 bg-[var(--brand)]/20" />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Process;
